<template>
  <div v-if="isOpen" class="dropdown-overlay" @click="closeDropdown"></div>
  <div class="dropdown-selector">
    <div class="dropdown-option" @click.stop="toggleDropdown">
      <span class="dropdown-text">{{ getSelectedLabel() }}</span>
      <svg-icon
        name="arrow-down"
        class="dropdown-icon"
        :class="{ 'rotate-180': isOpen }"
      />
    </div>

    <div
      v-if="isOpen"
      class="dropdown-options"
      :style="dropdownStyle"
      @click.stop
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="dropdown-option-item"
        :class="{ active: option.value === selected }"
        @click="selectOption(option.value)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default defineComponent({
  components: { SvgIcon },
  props: {
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      dropdownStyle: {
        top: "0",
        left: "0",
      },
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    getSelectedLabel() {
      const selectedOption = this.options.find(
        (option) => option.value === this.selected
      );
      return selectedOption ? selectedOption.label : this.selected;
    },
    toggleDropdown(event) {
      if (!this.isOpen) {
        const rect = event.currentTarget.getBoundingClientRect();
        this.dropdownStyle = {
          top: `${rect.bottom + 8}px`,
          left: `${rect.left}px`,
        };
      }
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    selectOption(option) {
      this.$emit("update:selected", option);
      this.closeDropdown();
    },
    handleClickOutside(event) {
      const dropdown = this.$el;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
  },
});
</script>

<style scoped lang="scss">
.dropdown-overlay {
  @apply fixed inset-0 z-40;
}

.dropdown-selector {
  @apply relative cursor-pointer z-50;

  .dropdown-option {
    @apply flex items-center justify-between p-3 lg:p-2 xl:p-3 bg-[#182828] rounded-2xl;

    .dropdown-text {
      @apply text-white text-[14px] leading-[21px];
    }

    .dropdown-icon {
      @apply w-6 h-6 text-[#F1FEF7] transition-transform duration-300 ml-5;
    }
  }

  .dropdown-options {
    @apply fixed z-50 w-[167px] bg-white rounded-2xl p-2 shadow-lg;
    @apply flex flex-col;

    .dropdown-option-item {
      @apply px-3 py-3 rounded-xl text-[#222222] text-[14px] leading-[21px] cursor-pointer transition-all duration-300;

      &:hover {
        @apply bg-[#f1f1f1] opacity-100;
      }

      &.active {
        @apply bg-[#f1f1f1] opacity-100 text-[#058242];
      }
    }
  }
}
</style>
